"use client"
import "./Header.css"
import { require } from 'react'
import { Link } from "react-router-dom"

const Header = ({ title, user, onLogout, toggleSidebar }) => {
  return (
    <header className="main-header">
      <div className="header-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <i className="material-icons">menu</i>
        </button>
        <h1 className="page-title">{title}</h1>
      </div>

      <div className="header-right">
        <div className="header-actions">
          <button className="header-action-btn">
            <i className="material-icons">notifications</i>
            <span className="notification-badge">3</span>
          </button>

          <div className="user-dropdown">
            <button className="user-dropdown-toggle">
              <div className="user-avatar-small">
                <img src={require('../../images/Untitled.jpeg')} alt="User Avatar" />
              </div>
              <span className="user-name-small">{user.name}</span>
              <i className="material-icons">arrow_drop_down</i>
            </button>

            <div className="dropdown-menu">
              <Link to="/admin/profile" className="dropdown-item">
                <i className="material-icons">person</i>
                Profile
              </Link>
              <Link to="/admin/settings" className="dropdown-item">
                <i className="material-icons">settings</i>
                Settings
              </Link>
              <div className="dropdown-divider"></div>
              <button onClick={onLogout} className="dropdown-item">
                <i className="material-icons">exit_to_app</i>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
